module.exports = __webpack_public_path__ + "static/media/iphone.8d318e4a.jpg";